/** Query keys for chat, slug-scoped like the rest of the v2 surface. */
export const chatKeys = {
  all: ['v2', 'chat'] as const,
  channels: (slug: string) => ['v2', 'chat', slug, 'channels'] as const,
  channel: (slug: string, id: string) => ['v2', 'chat', slug, 'channel', id] as const,
  messages: (slug: string, id: string) => ['v2', 'chat', slug, 'messages', id] as const,
}
